export default "__VITE_ASSET__Bxxtrvx$__"